import React from 'react';
import CartonMaterialsSection from 'components/quote_builder_widget/CartonMaterialsSection';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CartonMaterialsSectionWrapper = ({
  onMaterialsChange,
}) => {
  return (
    <div>
      <h4 className={styles.sectionHeader}>
        {t('quote_builder_widget.section_carton_materials')}
      </h4>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>
          {t('quote_builder_widget.carton_unit_prices') || 'Unit Prices'}
        </label>
        <p className={styles.helpText}>
          {t('quote_builder_widget.carton_unit_prices_info') || 'Select which unit prices are available in the widget for carton drawings.'}
        </p>

        <CartonMaterialsSection onMaterialsChange={onMaterialsChange} />
      </div>
    </div>
  );
};

export default CartonMaterialsSectionWrapper;
